import KumovegaError from "./KumovegaError";

export default class RequestMalformed extends KumovegaError {}
